<div class="info-card at-card">
  <div class="card-header">
    <span class="card-icon" [ngClass]="'is-' + meta.tono"><i [class]="meta.icon"></i></span>
    <div class="header-title-group">
      <span class="card-eyebrow">Pagos por atender</span>
      <h3>{{ meta.label }}</h3>
    </div>
    <div class="header-tags">
      <p-tag [value]="conteo(group) + (conteo(group) === 1 ? ' pago' : ' pagos')" severity="secondary"></p-tag>
      <button type="button" class="at-help-btn" (click)="ayuda.toggle($event)"
        pTooltip="¿Qué es esto y cómo se resuelve?" tooltipPosition="top" aria-label="Ayuda">
        <i class="fa-solid fa-circle-question"></i>
      </button>
      <button pButton type="button" icon="fa-solid fa-arrows-rotate" label="Actualizar"
        class="p-button-sm p-button-outlined" (click)="onReload.emit()" [disabled]="loading" [loading]="loading"></button>
    </div>
  </div>

  <!--
    Ayuda bajo demanda: el párrafo de arriba dice qué es el grupo; esto responde el resto —por qué
    llega un pago aquí, cómo elegir la acción y qué NO hace la herramienta— sin ocupar la pantalla
    de quien ya lo sabe.
  -->
  <p-overlayPanel #ayuda [style]="{ width: '480px', maxWidth: '92vw' }" styleClass="at-help-panel">
    <ng-template pTemplate="content">
      <h4 class="at-help-title"><i [class]="meta.icon"></i> {{ meta.label }}</h4>

      <section class="at-help-block">
        <h5>¿Por qué llega un pago aquí?</h5>
        <p>{{ meta.ayuda.porQue }}</p>
      </section>

      <section class="at-help-block" *ngIf="meta.ayuda.criterios?.length">
        <h5>¿Cómo sé qué hacer con cada uno?</h5>
        <p class="at-help-lead">La columna <strong>Diagnóstico</strong> ya trae la respuesta:</p>
        <div class="at-help-criterio" *ngFor="let c of meta.ayuda.criterios">
          <div class="at-help-criterio-head"><strong>{{ c.pill }}</strong><i class="fa-solid fa-arrow-right-long"></i><span>{{ c.accion }}</span></div>
          <p>{{ c.porque }}</p>
        </div>
      </section>

      <section class="at-help-block is-warn">
        <h5><i class="fa-solid fa-triangle-exclamation"></i> Ten en cuenta</h5>
        <p>{{ meta.ayuda.ojo }}</p>
      </section>

      <p class="at-help-foot">
        <i class="fa-solid fa-shield-halved"></i>
        Ningún ajuste se aplica sin previsualizar el impacto, escribir un motivo y confirmar las advertencias. Todos quedan en la bitácora del pago y se pueden deshacer.
      </p>
    </ng-template>
  </p-overlayPanel>

  <div class="card-content">
    <p class="at-explain">{{ meta.explicacion }}</p>

    <div class="at-loading" *ngIf="loading">
      <p-progressSpinner styleClass="at-spin" strokeWidth="4"></p-progressSpinner>
      <span>Revisando los pagos…</span>
    </div>

    <div class="empty-state" *ngIf="!loading && !rows.length">
      <i class="fa-solid fa-circle-check"></i>
      <h3>Nada por atender</h3>
      <p>{{ meta.vacio }}</p>
    </div>

    <div class="rf-table-wrap" *ngIf="!loading && rows.length">
      <p-table [value]="rows" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="46vh"
        [paginator]="rows.length > 25" [rows]="25">
        <ng-template pTemplate="header">
          <tr>
            <th>Cliente</th>
            <th>Clave de rastreo</th>
            <th class="text-center">Fecha</th>
            <th class="text-right">Monto</th>
            <th class="text-right">Aplicado</th>
            <th class="text-right">{{ group === 'remanentes' ? 'Remanente' : group === 'posiblesDuplicados' ? 'Por aplicar' : 'Anulado' }}</th>
            <th class="text-center">{{ group === 'posiblesDuplicados' ? 'Pagos iguales' : 'Diagnóstico' }}</th>
            <th class="text-center at-action-col"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td class="at-client" [title]="row.cliente || ''">{{ row.cliente || '—' }}</td>
            <td class="at-key" [title]="row.trackingKey || ''">{{ row.trackingKey || '—' }}</td>
            <td class="text-center">{{ row.fecha | date:'dd/MM/yyyy':'UTC' }}</td>
            <td class="text-right at-amount">{{ row.monto | currency:'MXN':'symbol':'1.2-2' }}</td>
            <td class="text-right">{{ row.aplicado | currency:'MXN':'symbol':'1.2-2' }}</td>
            <td class="text-right at-amount">{{ cifra(row) | currency:'MXN':'symbol':'1.2-2' }}</td>
            <td class="text-center">
              <ng-container [ngSwitch]="group">
                <!--
                  Dos números, sin conclusión: cuántos pagos iguales hay y cuántos arrendamientos
                  activos tiene el cliente. Quien decide es quien tiene el estado de cuenta.
                -->
                <ng-container *ngSwitchCase="'posiblesDuplicados'">
                  <span class="at-evidencia" *ngIf="evidencia(row) as e" [pTooltip]="evidenciaTooltip(row)" tooltipPosition="left">
                    <span class="at-evidencia-num" [class.is-sobran]="e.sobran > 0">{{ e.iguales }}</span>
                    <span class="at-evidencia-txt">{{ e.iguales === 1 ? 'único' : 'iguales' }} · {{ e.activos }} arrend.</span>
                  </span>
                </ng-container>
                <!-- Lo que decide qué hacer: si el arrendamiento todavía debe, el saldo se aplica -->
                <ng-container *ngSwitchCase="'remanentes'">
                  <p-tag *ngIf="row.sePuedeAplicar" severity="info" icon="fa-solid fa-arrow-right-long" value="Aún se puede aplicar"
                    [pTooltip]="destinoTooltip(row)" tooltipPosition="left"></p-tag>
                  <p-tag *ngIf="!row.sePuedeAplicar" severity="secondary" icon="fa-solid fa-check" value="Sin letra pendiente"
                    pTooltip="Su arrendamiento ya tiene todas las letras cubiertas: este residuo no tiene a dónde aplicarse." tooltipPosition="left"></p-tag>
                </ng-container>
                <p-tag *ngSwitchCase="'anulados'" severity="danger" icon="fa-solid fa-ban" [value]="(row.anuladoEl | date:'dd/MM/yyyy') || '—'"></p-tag>
              </ng-container>
            </td>
            <td class="text-center at-action-col">
              <button pButton type="button"
                [label]="group === 'anulados' ? 'Deshacer' : 'Ajustar'"
                [icon]="group === 'anulados' ? 'fa-solid fa-rotate-left' : 'fa-solid fa-wrench'"
                class="p-button-sm p-button-outlined" (click)="select(row)"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- El motivo con que se anuló: es lo que le dice al operador si conviene deshacerlo -->
    <p class="at-note" *ngIf="group === 'anulados' && rows.length">
      <i class="fa-solid fa-circle-info"></i>
      Al deshacer verás el motivo con que se anuló y podrás elegir qué ajuste revertir desde su historial.
    </p>
  </div>
</div>
